<template>
  <div id="escalation-creation">
    <p class="title-label">エスカレーション作成</p>
    <div class="content-area">
      <p class="caption-label">エスカレーション内容</p>
      <table>
        <tr>
          <th>コール日付</th>
          <td>{{ formatDate(callDetail.callImplementationDate) }}</td>
        </tr>
        <tr>
          <th>患者コード</th>
          <td>{{ callDetail.patientCode }}</td>
        </tr>
        <tr>
          <th>患者名</th>
          <td>{{ callDetail.patientName }}</td>
        </tr>
        <tr>
          <th>患者名カナ</th>
          <td>{{ callDetail.patientNameKana }}</td>
        </tr>
        <tr>
          <th>連絡先（携帯電話）</th>
          <td>
            {{ callDetail.patientMobilePhone }}
          </td>
        </tr>
        <tr>
          <th>連絡（自宅・その他）</th>
          <td>
            {{ callDetail.patientPhoneNumber }}
          </td>
        </tr>
        <tr>
          <th>性別</th>
          <td>{{ callDetail.gender }}</td>
        </tr>
        <tr>
          <th>年齢</th>
          <td>{{ callDetail.age }}</td>
        </tr>
        <tr>
          <th>医療機関名</th>
          <td>{{ callDetail.medicalInstitutionName }}</td>
        </tr>
        <tr>
          <th>エスカレーション種別<span class="require" /></th>
          <td>
            <select
              v-model="requestParams.escalationType"
              class="validation"
              name="エスカレーション種別"
              validate="required"
            >
              <option
                v-for="type in escalationTypeList"
                :key="type.code"
                :value="type.code"
              >
                {{ type.name }}
              </option>
            </select>
          </td>
        </tr>
        <tr>
          <th>お客様へのコールバック<span class="require" /></th>
          <td>
            <div>
              <b-radio
                class="td_radio"
                v-model="requestParams.callBack"
                :native-value="false"
                >不要</b-radio
              >
              <b-radio
                class="td_radio"
                v-model="requestParams.callBack"
                :native-value="true"
                >要</b-radio
              >
            </div>
          </td>
        </tr>
        <tr>
          <th>コールバック時間指定<span class="require" /></th>
          <td>
            <input
              v-model="requestParams.callBackTime"
              maxlength="20"
              class="validation"
              name="コールバック時間指定"
              validate="required"
            />
          </td>
        </tr>
        <tr>
          <th style="vertical-align: top">詳細内容</th>
          <td>
            <textarea
              v-model="requestParams.escalationContents"
              maxlength="256"
              class="detail-text"
            />
            <p>※聴取内容、誰からDB希望か、登録先情報の変更、など</p>
          </td>
        </tr>
        <tr>
          <th>コールセンター架電者名<span class="require" /></th>
          <td>
            <input
              v-model="requestParams.callStaffName"
              maxlength="100"
              class="validation"
              name="コールセンター架電者名"
              validate="required"
            />
          </td>
        </tr>
      </table>
    </div>
    <div class="button-area">
      <b-button class="receptionistButton is-primary" @click="saveEscalation"
        >保存する</b-button
      >
    </div>
  </div>
</template>

<script>
import { escalationTypeList } from "@/components/mock/base/const.js";
export default {
  data() {
    return {
      escalationTypeList,
      requestParams: {
        id: 0,
        callId: "",
        escalationType: null,
        callBack: false,
        callBackTime: "",
        escalationContents: "",
        callStaffName: "",
        status: 1,
      },
    };
  },
  props: {
    callDetail: {},
  },
  methods: {
    formatDate(date) {
      return date ? date.replace(/-/g, "/") : "";
    },
    saveEscalation() {
      let div = document.getElementById("escalation-creation");
      let elements = div.getElementsByClassName("validation");
      let result = this.selfMadeValidation(elements);
      if (result.isError) {
        this.showErrorMessage(result.msg);
        return;
      }
      let executeApi = this.saveCallEscalationDetail;
      let successCallBack = this.saveCallEscalationDetailSuccess;
      let errorCallBack = this.saveCallEscalationDetailError;
      this.apiCall(executeApi, successCallBack, errorCallBack);
    },
    saveCallEscalationDetail(client) {
      let body = JSON.parse(JSON.stringify(this.requestParams));
      return client.apis.internalCpap.setCpapEscalationDetailsPOST({
        body: body,
      });
    },
    saveCallEscalationDetailSuccess(result) {
      this.showSuccess(result, () => { this.$emit("sendBack") });
    },
    saveCallEscalationDetailError: function (result) {
      this.showErrorMessage(result);
    },
    setRequestParams() {
      this.requestParams.callId = this.callDetail.callId;
      this.requestParams.callStaffName = this.callDetail.callStaffName;
    }
  },
  created() {
    this.setRequestParams();
  }
};
</script>

<style scoped>
#escalation-creation {
  padding: 1em;
}
.title-label {
  background-color: #000894;
  color: whitesmoke;
  text-align: left;
  padding: 0 10px;
}
.caption-label {
  font-size: 18px;
}
.content-area {
  margin-top: 10px;
  padding: 10px;
  width: 100%;
  border: 1px solid;
  border-radius: 5px;
}
.content-area table tr th {
  width: 25%;
  font-size: 15px;
  vertical-align: middle;
  padding: 0.2em 0;
}
.content-area table tr td {
  font-size: 15px;
  vertical-align: middle;
  padding: 0.2em 0;
}
.content-area table tr td > * {
  width: 100%;
}
.detail-text {
  height: 60px;
  resize: vertical;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/call/components/EscalationCreationDialog.vue